import React, {Component} from "react";

const styles = {
    fullScreenImg: {
        display:'block',
        width:'100%',
        objectFit: 'cover'
    }
};

class FullScreenImage extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const imgSrc = this.props.imgSrc;
        return <div>
            <img src={imgSrc} alt="" style={styles.fullScreenImg}/>
        </div>
    }
}

export default FullScreenImage;
